import React from 'react';
import PaymentLogo from 'scy/PaymentLogo';
import { RadioList, RadioListItem } from 'scy/RadioList';
import { SecondarySmallUppercase } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import { flex, centerItems } from 'scy/flex.mod.scss';
import { tabular } from 'scy/utils.mod.scss';

export default function PaymentMethodPicker({
  paymentMethods,
  onChange,
  selectedItem
}) {
  return (
    <RadioList className={margin.bottom_sm}>
      {(paymentMethods || []).map(method => (
        <RadioListItem
          key={method.id}
          name="payment-method"
          id={method.id}
          onChange={() => onChange(method)}
          checked={selectedItem ? selectedItem.id === method.id : false}
          title={`${method.brand}` + (method.last4 ? ` ${method.last4}` : '')}
          aside={
            <div className={`${flex} ${centerItems} ${tabular}`}>
              <ExpirationDate month={method.exp_month} year={method.exp_year} />
              <PaymentLogo brand={method.brand} />
            </div>
          }
        />
      ))}
    </RadioList>
  );
}

function toTwoDigits(number) {
  const n = Number(number);
  return n < 9 ? `0${n}` : n > 100 ? `${n % 100}` : `${n}`;
}

function ExpirationDate({ month, year }) {
  if (!month || !year) return null;

  return (
    <SecondarySmallUppercase tag="span" className={margin.right_xs}>
      Expires {toTwoDigits(month)}/{toTwoDigits(year)}
    </SecondarySmallUppercase>
  );
}
